import { createAction, props } from '@ngrx/store';
import { RevendedorForm, Revendedor } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const RESELLER_FIND = createAction('[Reseller] Find', props<{ id: string }>());
export const RESELLER_FIND_ALL = createAction('[Reseller] Find All');

export const RESELLER_FIND_SUCCESS = createAction('[Reseller] Find Success', props<{ reseller: Revendedor }>());
export const RESELLER_FIND_ALL_SUCCESS = createAction('[Reseller] Find All Success', props<{ resellerList: Revendedor[] }>());

export const RESELLER_FAILURE = createAction('[Reseller] Failure', props<{ error: ResponseBadRequest }>());

export const RESELLER_UPDATE_LOADING = createAction('[Reseller] Update Loading', props<{ loading: boolean }>());
export const RESELLER_UPDATE_FORM = createAction('[Reseller] Update Form', props<{ resellerForm: RevendedorForm }>());
export const RESELLER_EDIT_MODE = createAction('[Reseller] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const RESELLER_UPDATE_ID = createAction('[Reseller] Update Id', props<{ resellerId: string|null }>());

export const RESELLER_CREATE_VIEW = createAction('[Reseller] Create View');
export const RESELLER_UPDATE_VIEW = createAction('[Reseller] Update View', props<{ resellerId: string }>());

export const RESELLER_CREATE = createAction('[Reseller] Create');
export const RESELLER_UPDATE = createAction('[Reseller] Update');
export const RESELLER_UPDATE_ENABLED = createAction('[Reseller] Update Enabled', props<{ id: string, resellerForm: RevendedorForm }>());
export const RESELLER_REMOVE = createAction('[Reseller] Remove', props<{ id: string }>());

export const RESELLER_CREATE_COMPLETED = createAction('[Reseller] Create Completed');
export const RESELLER_UPDATE_COMPLETED = createAction('[Reseller] Update Completed');
export const RESELLER_REMOVE_COMPLETED = createAction('[Reseller] Remove Completed');

export const RESELLER_RESET = createAction('[Reseller] Reset');
export const RESELLER_RESET_FORM = createAction('[Reseller] Reset Form');
export const RESELLER_RESET_ERROR = createAction('[Reseller] Reset Error');
export const RESELLER_CLEAR_STATE = createAction('[Reseller] Clear State');

export const RESELLER_FIND_NAME = createAction('[Reseller] Reseller find name', props<{ nombre: string }>())
export const RESELLER_FIND_FORM_SUCCESS = createAction('[Reseller] Find Form Success', props<{ resellerForm: RevendedorForm }>());